import { Component, ElementRef, Inject, Input, OnChanges, OnInit, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { ClevertapService } from '../../shared/services/clevertap/clevertap.service';
import { RootService } from '../../shared/services/root.service';
import { SkeletonService } from '../../shared/services/skeleton.service';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../shared/services/apiService.service';
import { WishlistService } from '../../shared/services/wishlist.service';
import { isPlatformBrowser } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { FormErrorService } from 'src/app/shared/form-validation/form-error.service';
import { RegexService } from 'src/app/shared/form-validation/regex.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';


@Component({
  selector: 'app-tata-ok-similar-vehicle',
  templateUrl: './tata-ok-similar-vehicle.component.html',
  styleUrls: ['./tata-ok-similar-vehicle.component.scss']
})
export class TataOkSimilarVehicleComponent implements OnInit,OnChanges  {
  @Input() cat_id:any;
  @Input() sub_cat_id:any;
  @Input() sub_cat_detail_id:any;
  @Input() state:any;
  @ViewChild(BreadcrumbComponent) breadCrumb: BreadcrumbComponent;
  environment1 = environment.s3bucket.url;
  VehicleId: any;
  disableForm: boolean = false;
  userFormsimilar: FormGroup;
  errorMessage: any;
  productLoaded: boolean;
  userData: any;
  showLoader: boolean = false;
  @ViewChild('myCheckbox') myCheckbox!: ElementRef;
  @ViewChild('closeBtn') closeBtn!: ElementRef;
  utm_source: any;
  utm_medium: any;
  utm_campaign: any;
  gclid: any;
  campaign_id:any
  userLoginForm: FormGroup;
  isshowLogin: boolean = true;
  isshowOtp: boolean = false;
  isshowSignUp: boolean = false;
  isSentOTP: boolean = false;
  closeResult: string;
  checkBoxControl = new FormControl(false);
  constructor(private activatedRoute: ActivatedRoute,private behaviourSub: BehaviourSubjectService, private regexService: RegexService,private fb: FormBuilder,private formErrorService: FormErrorService,private rootService: RootService,private WishlistService: WishlistService,private apiService :ApiService,private router :Router,@Inject(PLATFORM_ID) private platformId: Object,private cleverService: ClevertapService,private localStorage: secureStorage, private toastrService: ToastrService, public skeletonService: SkeletonService,private spinner: NgxSpinnerService) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cat_id'] || changes['sub_cat_id'] || changes['sub_cat_detail_id']) {
    
      this.getPopularVehicle(0) ;
      this.userform();
      this.getUserdata();
      this.campaign()
    }
  }
  campaign() {
    this.activatedRoute.queryParams.subscribe(async (params: any) => {
      this.utm_source = await params['utm_source'];
      this.utm_medium = await params['utm_medium'];
      this.utm_campaign = await params['utm_campaign'] || await params['utm_campaignname'];
      this.gclid = await params['gclid'];
      this.campaign_id = await params['campaign_id'];
    })
  }
  popularVehicleListLoad: boolean = false

  popularVehicleList: any = [] ;
  sub: Subscription = new Subscription
  isUserLoggedIn: any;

  lob: any;
  heartUrls = {
    empty: '../../../assets/images/Star-unfilled.svg',
    half: '../../../assets/images/Star-unfilled.svg',
    full: '../../../assets/images/Star-filled.svg',
  };

  customOptions3: OwlOptions = {
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    margin: 14,
    navText: [
      `<img alt="left" src=${this.environment1}assets/images/c-arrow-left.svg>`,
      `<img alt="right" src=${this.environment1}assets/images/c-arrow-right.svg>`
   ],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      600: {
        items: 1
      },
      940: {
        items: 3
      },
      1200: {
        items: 4
      }
    },
    nav: true
  }
  dealercode: string;
  ngOnInit(): void {
    this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
    this.sub.add(
      this.behaviourSub.isLoggedIn.subscribe(() => {
        this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
        this.userData = this.rootService.getUserData();
          if(this.isUserLoggedIn){
            this.closeModel()
          }
      })
    );
    this.sub.add(this.behaviourSub.isTataOkPLPPage.subscribe((ele)=>{
    if(ele){
      if (isPlatformBrowser(this.platformId)) {
        let element = document.getElementById('otpVerification');
        element.click();
      }
    }
    }));
    if (isPlatformBrowser(this.platformId)) {
    this.dealercode = localStorage.getItem('dealercd');
    }
    this.sub.add(this.behaviourSub.isTataOkLogin.subscribe((ele)=>{
      let data = {
        name:this.userData?.first_name + ' ' + this.userData?.last_name,
        contact:this.userData?.mobile_number
      }
     if(ele && this.VehicleId){
      this.createLead(data);
     }
    }));
    this.dealercode = localStorage.getItem('dealercd');

    this.getPopularVehicle(0)
    this.userform();
    this.setLoginHome();
    this.getUserdata()
  }

  onlyNumberKey(event: any) {
    return this.regexService.NumberKeyEvent(event);
  }

  getPopularVehicle(val:any) {
    const state = [this.state];
    let data = {
      offset: val,
      cat:this.cat_id,
      sub_cat:this.sub_cat_id,
      sub_cat_detail:this.sub_cat_detail_id,
      params_approval_status:'APPROVED',
      state:state,
      distributor_code:this.dealercode ? this.dealercode : ''
    };
    this.spinner.show()
      try {
        this.sub.add(this.apiService.getTataokhomedata(data).subscribe(
          (res) => {
            this.popularVehicleListLoad = true
            if (res.success) {
              this.popularVehicleList=res?.data
              this.popularVehicleList.forEach(element => {
                element.vehicle_documents.sort((a, b) => (a.is_cover === true ? -1 : 1));
              });
              this.spinner.hide();

            } else {
              this.popularVehicleList = []
              this.popularVehicleListLoad = true
              this.spinner.hide();
            }
          },
          () => {
            this.popularVehicleListLoad = true
            this.spinner.hide();
          }
        ))
      } catch (error) {
        this.popularVehicleListLoad = true
        this.spinner.hide();
      }
  }

  bookNow(data) {
    if (this.isUserLoggedIn) {
      let sublob = data.sub_lob?.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (data.sub_lob?.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : data.sub_lob?.replace(/\s/g, "-")?.toLowerCase();
      let model = data.model?.replace(/\s/g, '-')?.replace(/\//g, '-')?.replace(/\+/g, '-')?.replace(/\./g, '-')?.toLowerCase();
      this.router.navigate(['/lead-booking/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id]);
    }
    else {
      let sublob = data.sub_lob?.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (data.sub_lob?.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : data.sub_lob?.replace(/\s/g, "-")?.toLowerCase();
      let model = data.model?.replace(/\s/g, '-')?.replace(/\//g, '-')?.replace(/\+/g, '-')?.replace(/\./g, '-')?.toLowerCase();
      if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem('previousUrl', '/lead-booking/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id)
      }
      this.router.navigate(['/login/']);
    }
  }

  openProduct(data: any) {
    let sublob = (data.sub_lob == 'SCV Pickups' ? 'scv-pickups' : data.sub_lob == 'Icv Trucks' ? 'trucks' : 'buses-vans')?.toLowerCase();
    let lob = data.lob?.replace(/\s/g, "-")?.toLowerCase();;
    let ppl = data.ppl_seo;
    let pl = data.pl?.replace(/\s/g, "-")?.toLowerCase();
    this.router.navigate(['/product-details/' + sublob + '/' + lob + '/' + ppl + '/' + pl + '/' + data.id])
  }



  userform(){
    this.userFormsimilar = this.fb.group({
      name: ['', [Validators.required]],
      contact: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      consent: ['', Validators.required]
    });
  }

  contactDealer(id:any){
    this.disableForm=false;
    this.VehicleId=id;
    this.checkBoxcheked=false
    this.checkBoxControl.setValue(false);
    this.setForm()
  }

  notAllowSpace(event: any) {
    if (event.target.selectionStart === 0 && event.which === 32) {
      event.preventDefault();
    }
  }

  checkBoxcheked:boolean=false;

  onCheckboxChange(checked: boolean) {
    if (checked) {
      this.checkBoxcheked=true
    } else {
      this.checkBoxcheked=false
    }
  }

  onSubmit() {
    if (this.userFormsimilar.valid) {
      this.spinner.show()
      this.showLoader = true;
      this.createLead(this.userFormsimilar.value)
    } else {
      this.disableForm=false;
    }
  }

  redirect(id:number){
    this.router.navigate([`/buy-used-vehicles-productdetail/${id}`])
  }


  createLead(data:any){
    this.errorMessage = ''
    const nameParts = data.name.split(' ');
    const firstName = nameParts[0];
    const lastName = nameParts[1];
   let Payload={
    "first_name":firstName?firstName:'',
    "last_name": lastName?lastName:'',
    "mobile_no":data.contact,
    "vehicle_id":this.VehicleId,
    "lead_source":"osp",
    "financing":data.consent == 'yes' ? true : false,
    "address_one":this.userData.address_one,
          "address_two":this.userData.address_two,
          "city":this.userData.city,
          "district":this.userData.district,
          "pincode":this.userData.pincode,
          "state":this.userData.state,
          "taluka":this.userData.taluka,
          "utm_source":this.utm_source ? this.utm_source : '',
          "utm_medium":this.utm_medium  ? this.utm_medium : '',
         "utm_campaign":this.utm_campaign ? this.utm_campaign : '',
         "campaign_id":this.campaign_id ? this.campaign_id : '',
         "device_source":"Fleet Verse Web"
   };
   this.spinner.show()
   this.showLoader = true;
   try {
    this.sub.add( this.apiService.getCreateLead(Payload).subscribe({
      next: (response) => {
        if (response.success) {
          this.disableForm=true;
          this.productLoaded=true
          this.errorMessage=response;
          this.spinner.hide();
          this.showLoader = false;
        }

        else{
          this.showLoader = false;
        this.spinner.hide();
          this.toastrService.warning(response?.data?.msg);
          if (isPlatformBrowser(this.platformId)) {
            let element =document.getElementById('closeBtn');
            element.click();
          }
        }
      },
      error: (error) => {
        this.showLoader = false;
        this.spinner.hide();
        if (isPlatformBrowser(this.platformId)) {
          let element =document.getElementById('closeBtn');
          element.click();
        }
      },
     })
    )
  } catch (error) {
  }

  }

  getUserdata(){
    this.sub.add(this.apiService.getUserData().subscribe({
      next: (response: any) => {
      this.userData=response?.data;
      }
    }));
  }
  setForm(){
    if (isPlatformBrowser(this.platformId)) {
    const fullName = this.userData?.first_name + ' ' + this.userData?.last_name;
    this.userFormsimilar = this.fb.group({
      name: [fullName ? fullName :'', [Validators.required]],
      contact: [this.userData?.mobile_number ? this.userData?.mobile_number : '', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      consent: ['yes', Validators.required]
    });
    this.myCheckbox.nativeElement.checked = false;
    if (this.userFormsimilar.controls['contact'].invalid) {
      this.userFormsimilar.controls['contact'].markAsTouched();
    }
  }
  }
  getiscover(data:any){
    if (data.length > 0) {
      const original_data = data
      const images = [...data];
      const filteredImages = images.filter(item => item.is_cover === true);
      if (filteredImages.length > 0) {
          return filteredImages[0].path
      } else {
          return original_data[0].path
      }
    }
    else{
      return '../../../assets/images/default_image.jpg'
    }

  }
  getFirstPartOfOwners(owners: string | undefined): string {
    if (!owners) {
      return '';
    }
    return owners.split(/[-\s]/)[0];
  }

  closeModel() {
    if (isPlatformBrowser(this.platformId)) {
      let element = document.getElementById('closeBtn1');
     
      if(element && this.isshowLogin){
        element.click();
      }
      let element1 = document.getElementById('closeBtn2');
      if(element1){
        element1.click();
      }
    }
  }

  setLoginHome(){
    if (isPlatformBrowser(this.platformId)) {
    this.userLoginForm = this.fb.group({
      mobile_number: [this.userData?.mobile_number ? this.userData?.mobile_number : '', [Validators.required, Validators.pattern(this.regexService.Phone)]],
    });
    }
  }

  

  showLogin() {
    this.isshowLogin = true;
    this.isshowOtp = false;
    this.isshowSignUp = false;
     if (isPlatformBrowser(this.platformId)) {
    if(window.location.href.includes('buy-used-vehicles')){
      let ele = document.getElementById('otpVerification')
      ele.click(); 
    }
  }
  }

  showOtp() {
    this.isshowLogin = false;
    this.isshowOtp = true;
    this.isshowSignUp = false;
  }

  showSignup(){
    this.isshowLogin = false
    this.isshowOtp = false;
    this.isshowSignUp = true;
  }

  sentOtp() {

      if (this.isSentOTP) {
        return;
      }
      this.isSentOTP = true;
      if (this.userLoginForm.status === 'INVALID') {
        this.formErrorService.displayFormErrors(this.userLoginForm);
        return;
      }
      this.spinner.show();
      let data = {
        mobile_number: this.userLoginForm.controls['mobile_number'].value,
        action_type: 'login',
        user_source: "Tataok"
      };
      this.sub.add(
        this.apiService.sentOtp1(data).subscribe({
          next: (response: any) => {
            this.isSentOTP = false;
            if (response.success) {

              this.toastrService.success(response.data.msg);
              if(this.checkBoxcheked && this.userLoginForm.controls['mobile_number']?.value){
                this.getConsentData(this.userLoginForm.controls['mobile_number']?.value)
              }
              this.spinner.hide();
                             if (isPlatformBrowser(this.platformId)) {
              this.localStorage.setItem("loginNumber", JSON.stringify(this.userLoginForm.controls['mobile_number'].value))
              localStorage.removeItem("signup")
                             }
              this.isshowLogin = false
              this.isshowOtp = true;
              this.isshowSignUp = false;

              // this.router.navigate(['/otp/']);
              if (isPlatformBrowser(this.platformId)) {
                window.scroll(0, 0);
              }
            
            }
            else {
                  this.toastrService.warning('Something went wrong!');
                  this.spinner.hide();
                  this.closeModel()
                }
          },
          error: () => {
            this.toastrService.warning('Something went wrong!');
            this.spinner.hide();
            this.closeModel()
          },
          complete: () => { },
        })
      );
    
  }

  getConsentData(value) {
    if (isPlatformBrowser(this.platformId)) {
    const signup = JSON.parse(this.localStorage.getItem("signup")) ? true : false;
    let data = {
      "mobile_number": value,
      'source': signup ? 'Web Registration' : 'Web Login'
    }
    this.apiService.get_amc_consent_view(data).subscribe((res) => {
    })
  }
  }
  
  ngOnDestroy() {
    this.sub.unsubscribe()
  }

}
